// extracted by mini-css-extract-plugin
export default {"gw_icone_panier":"panier_gw_icone_panier__z26gT","item_panier":"panier_item_panier__PWg3z"};